import { render } from "./ReturnHistory.vue?vue&type=template&id=1f32950e"
import script from "./ReturnHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./ReturnHistory.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/codebuild/output/src3003388635/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/portal-dev-frontend/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/components/templates/returnHistory/ReturnHistory.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1f32950e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1f32950e', __exports__)) {
    console.log('reload')
    api.reload('1f32950e', __exports__)
  }
  
  module.hot.accept("./ReturnHistory.vue?vue&type=template&id=1f32950e", () => {
    console.log('re-render')
    api.rerender('1f32950e', render)
  })

}


export default __exports__